import { BlockBlobClient } from '@azure/storage-blob';
import { logToAppInsights } from './AppInsights';

const BlobUploadUtils = {};

BlobUploadUtils.createBlockBlobClient = async (storageUrlWithBlobSasToken) => {
  const blockBlobClient = new BlockBlobClient(storageUrlWithBlobSasToken);
  return blockBlobClient;
};

BlobUploadUtils.uploadToBlobStorage = async (
  blockBlobClient,
  file,
  _setUploadProgress,
  abortSignal
) => {
  _setUploadProgress(0);

  const startMessage = `Uploading file \"${file.name}\" to azure storage.`;
  console.log(startMessage);
  logToAppInsights('Starting file upload.', startMessage);

  await blockBlobClient.uploadData(file, {
    abortSignal: abortSignal,
    onProgress: (val) => _handleUploadProgress(file.size, val, _setUploadProgress),
  });

  const successMessage = 'Finished file upload.';
  console.log(successMessage);
  logToAppInsights('Finished file upload.', successMessage, 'success');
};

function _handleUploadProgress(fileSize, progressValue, _setUploadProgress) {
  let percentage = (progressValue.loadedBytes / fileSize) * 100;
  if (percentage >= 100) {
    _setUploadProgress(100);
  } else {
    _setUploadProgress(percentage);
  }
}

export default BlobUploadUtils;
